<div class="inlineEditWrapper" [ngClass]="{'long-text': (mode =='textarea') }" >

  @if (mode != 'textarea') {
    <a (click)="edit(value)" class="edit-link" [hidden]="editing" [title]="title">
      {{ (value) ? (value | formatcc) : empty }}
    </a>
  }

  @if (mode == 'textarea') {
    <div [hidden]="editing" [title]="title">
      <div>
        {{ (value)? value : empty }}
        @if (editable) {
          <span class="edit-textarea kt-badge kt-badge--primary kt-badge--inline kt-badge--pill" (click)="edit(value)">
            {{ 'common.edit' | t:'Edit' }}
          </span>
        }
      </div>
    </div>
  }

  <div class="inlineEditForm" [hidden]="!editing" (focusout)="focusout($event)">

    @if (mode == 'text') {
      <input #rocketinput type="text" class="form-control form-control-sm" [formControl]="editValue" (keyup.enter)="save()" />
    }
    @if (mode == 'number') {
      <input #rocketinput type="number" class="form-control form-control-sm" [formControl]="editValue" (keyup.enter)="save()" />
    }
    @if (mode == 'email') {
      <input #rocketinput type="email" class="form-control form-control-sm" [formControl]="editValue" (keyup.enter)="save()" />
    }
    @if (mode == 'date') {
      <input #rocketinput type="date" class="form-control form-control-sm" [formControl]="editValue" (keyup.enter)="save()" />
    }
    @if (mode == 'single-select') {
      <ng-select [items]="options" [formControl]="editValue" #rocketinput class="form-control form-control-sm" [placeholder]="'common.select' | t:'Select'"></ng-select>
    }
    @if (mode == 'multi-select') {
      <ng-select [multiple]="true" [items]="options" [formControl]="editValue" #rocketinput class="form-control form-control-sm" [placeholder]="'common.select' | t:'Select'"></ng-select>
    }
    @if (mode == 'emails') {
      <tag-input [theme]="'foundation-theme'" [placeholder]="'core.rocket_edit.add_email' | t:'+ Add Email'" [secondaryPlaceholder]="'core.rocket_edit.enter_email' | t:'Enter Email'"  [modelAsStrings]="true" [separatorKeys]="[',', ';']" [formControl]="editValue" #rocketinput class="form-control form-control-sm"></tag-input>
    }

    @if (mode == 'textarea') {
      <textarea #rocketinput type="text" class="form-control form-control-sm" [formControl]="editValue">
      </textarea>
    }

    <button (click)="cancel()"  class="btn btn-icon editor-button-close" type="button" [title]="'common.cancel' | t:'Cancel'"><i class="flaticon2-cross"></i></button>
    <button (mousedown)="save()" [disabled]="!validate()" class="btn btn-brand btn-icon svg-white editor-button-save" type="button" [title]="'common.save_changes' | t:'Save Changes'">
      <span class="svg-icon svg-icon-2x">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24"/>
            <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
          </g>
        </svg>
      </span>
    </button>

  </div>

</div>